export function hasLiveDemoUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url.trim());
}

/** Map a catalog row from products.json / projects.json into the detail page shape. */
export function normalizeCatalogItem(item) {
  if (!item) return null;
  return {
    title: item.name,
    summary: item.text,
    subtitle:
      typeof item.subtitle === "string" && item.subtitle.trim()
        ? item.subtitle.trim()
        : typeof item.tagline === "string" && item.tagline.trim()
          ? item.tagline.trim()
          : "",
    overview: item.overview ?? item.description ?? item.text,
    features: Array.isArray(item.features) ? item.features : [],
    sections: item.sections,
    detailCardTitle: item.detailCardTitle,
    ctas: item.ctas,
    externalUrl: typeof item.url === "string" ? item.url.trim() : "",
  };
}

export function slugifyCatalogName(name) {
  if (!name || typeof name !== "string") return "";
  return name
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function findCatalogBySlug(list, slug) {
  if (!slug) return null;
  const bySlug = list.find((p) => p.slug === slug);
  if (bySlug) return bySlug;
  return list.find((p) => slugifyCatalogName(p.name) === slug) ?? null;
}
